/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.SheetExcelConfiguration = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The SheetExcelConfiguration model module.
   * @module model/SheetExcelConfiguration
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>SheetExcelConfiguration</code>.
   * @alias module:model/SheetExcelConfiguration
   * @class
   */
  var exports = function() {
    var _this = this;










  };

  /**
   * Constructs a <code>SheetExcelConfiguration</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SheetExcelConfiguration} obj Optional instance to populate.
   * @return {module:model/SheetExcelConfiguration} The populated <code>SheetExcelConfiguration</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('TemplateFileBlobStorageURI')) {
        obj['TemplateFileBlobStorageURI'] = ApiClient.convertToType(data['TemplateFileBlobStorageURI'], 'String');
      }
      if (data.hasOwnProperty('MicrosoftDriveFileID')) {
        obj['MicrosoftDriveFileID'] = ApiClient.convertToType(data['MicrosoftDriveFileID'], 'String');
      }
      if (data.hasOwnProperty('IsValidFile')) {
        obj['IsValidFile'] = ApiClient.convertToType(data['IsValidFile'], 'Boolean');
      }
      if (data.hasOwnProperty('MicrosoftDriveURL')) {
        obj['MicrosoftDriveURL'] = ApiClient.convertToType(data['MicrosoftDriveURL'], 'String');
      }
      if (data.hasOwnProperty('MicrosoftDriveID')) {
        obj['MicrosoftDriveID'] = ApiClient.convertToType(data['MicrosoftDriveID'], 'String');
      }
      if (data.hasOwnProperty('MicrosoftShareURL')) {
        obj['MicrosoftShareURL'] = ApiClient.convertToType(data['MicrosoftShareURL'], 'String');
      }
      if (data.hasOwnProperty('LocalFileName')) {
        obj['LocalFileName'] = ApiClient.convertToType(data['LocalFileName'], 'String');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {String} TemplateFileBlobStorageURI
   * @default ''
   */
  exports.prototype['TemplateFileBlobStorageURI'] = '';
  /**
   * @member {String} MicrosoftDriveFileID
   * @default ''
   */
  exports.prototype['MicrosoftDriveFileID'] = '';
  /**
   * @member {Boolean} IsValidFile
   * @default false
   */
  exports.prototype['IsValidFile'] = false;
  /**
   * @member {String} MicrosoftDriveURL
   * @default ''
   */
  exports.prototype['MicrosoftDriveURL'] = '';
  /**
   * @member {String} MicrosoftDriveID
   * @default ''
   */
  exports.prototype['MicrosoftDriveID'] = '';
  /**
   * @member {String} MicrosoftShareURL
   * @default ''
   */
  exports.prototype['MicrosoftShareURL'] = '';
  /**
   * @member {String} LocalFileName
   * @default ''
   */
  exports.prototype['LocalFileName'] = '';
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


